import React, { useState } from "react";
import { copyWarmUpAssignment, fetchWarmUpFreeCodesByClass } from "components/pages/WarmUpPicker/warmUpApi";
import { newRequestId } from "components/pages/WarmUpPicker/requestId";
import { CopyLessonModal } from "./CopyLessonModal";

// Copy to Classes on a warm-up card: the lesson copy frame (Figma 5511:79462)
// with warm-up wording, which Figma does not draw.

const TITLE = "Copy Your Warm-Up To More Classes";

const BLURB =
  "Select one or more Classes to copy these warm-up groups, with the same number of groups and session length.";

const INELIGIBLE_TIP =
  "This class can’t be selected because it doesn’t have enough available group codes. "
  + "Archive old groups to clear additional group codes.";

const NOT_ENOUGH_CODES = /^Class .+ has \d+ free group codes but these warm-up groups need \d+$/;

const FAILURES = {
  "This warm-up set is no longer available": { message: "This warm-up set is no longer available." },
  "This warm-up assignment has no groups to copy": { message: "These warm-up groups have no group codes to copy." },
  "Classroom not found": { message: "One of these classes is no longer available.", refreshAccount: true },
  "Warm-up assignment not found": { gone: true },
};

const OTHER_FAILURE = { message: "Your warm-up groups were not copied. Try again." };

// A raced 409 names the class short of codes: shown as is, and the rows are
// read again so it greys out.
const copyFailureOf = (error) => {
  const detail = error?.detail;
  if (error?.status === 409 && NOT_ENOUGH_CODES.test(detail)) return { message: detail, rereadFreeCodes: true };
  const known = FAILURES[detail];
  const expectedStatus = known?.gone || known?.refreshAccount ? 404 : 409;
  return known && error.status === expectedStatus ? known : OTHER_FAILURE;
};

// Mounted once per opening, so its key is made once per opening.
export const WarmUpCopyModal = ({ assignment, classroomId, classes, onClose, onCopied, onGone, onAccountRefresh }) => {
  const [clientRequestId] = useState(newRequestId);
  const save = (targetClassroomIds) =>
    copyWarmUpAssignment(classroomId, assignment.id, { targetClassroomIds, clientRequestId }).then(
      (body) => body?.copies || []
    );

  return (
    <CopyLessonModal
      isOpen
      onClose={onClose}
      classroomId={classroomId}
      assignmentId={assignment.id}
      lessonLabel="Warm-Up Groups"
      lessonName={assignment.warmup_set.name}
      classes={classes}
      requiredCount={assignment.groups.length}
      title={TITLE}
      blurb={BLURB}
      ineligibleTip={INELIGIBLE_TIP}
      loadFreeCodes={fetchWarmUpFreeCodesByClass}
      save={save}
      onCopied={onCopied}
      failureOf={copyFailureOf}
      onGone={onGone}
      onAccountRefresh={onAccountRefresh}
    />
  );
};
